import api from '../../api/userAPI';
import {
  setSuccessNotification,
  setErrorNotification
} from '../snackbarNotification';

export const ADD_BEGIN = 'medicalRecord.add/ADD_BEGIN';
export const ADD_SUCCESS = 'medicalRecord.add/ADD_SUCCESS';
export const ADD_FAILED = 'medicalRecord.add/ADD_FAILED';

const addBegin = () => ({ type: ADD_BEGIN });
const addSuccess = () => ({ type: ADD_SUCCESS });
const addFailed = error => ({ type: ADD_FAILED, payload: error });
export const addMedicalRecord = data => async dispatch => {
  dispatch(addBegin());

  const formData = new FormData();
  formData.append('appointment_id', data.appointmentID);
  formData.append('description', data.description);
  formData.append('medication', data.medication);
  formData.append('mc_attachment', data.attachment);

  try {
    await api({
      url: 'add-medical-record',
      method: 'POST',
      data: formData,
      headers: {
        'content-type': 'multipart/form-data'
      }
    });

    dispatch(addSuccess());
    dispatch(setSuccessNotification('Successfully added data'));
  } catch (error) {
    dispatch(addFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_BEGIN:
      return { ...state, completed: false, isLoading: true, error: null };

    case ADD_SUCCESS:
      return { ...state, completed: true, isLoading: false };

    case ADD_FAILED:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
};

export default reducer;

const initialState = {
  completed: false,
  isLoading: false,
  error: null
};
